import { AllocationSignal } from "@timeedit/registration-schemas";
import cn from "classnames";
import "./signalBadge.scss";
import { Badge } from "../Badge";

interface SignalBadgeProps {
  signal: AllocationSignal;
  translations: {
    registered: string;
    notRegistered: string;
  };
  className?: string;
}
export function SignalBadge({
  signal,
  className = "",
  translations,
}: SignalBadgeProps): React.JSX.Element {
  if (signal === "OK") {
    return (
      <Badge
        status="success"
        className={cn("signal-badge", className)}
        text={`${translations.registered}`}
      />
    );
  }
  return (
    <Badge
      status="error"
      className={cn("signal-badge", className)}
      text={`${translations.notRegistered}`}
    />
  );
}
